var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"available-demographics"},[_c('h2',[_vm._v("Select Demographic")]),_c('v-select',{attrs:{"label":"id","options":_vm.demographicsListing},on:{"input":_vm.setSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }